angular.module('app')
    .controller('manageEmailTemplateController', manageEmailTemplateController);

manageEmailTemplateController.$inject = [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'etKey',
    'EmailTemplatesApi',
    'locations',
    'ISO3166',
    'handleError',
    '$timeout'
];

function manageEmailTemplateController(
    $scope,
    $rootScope,
    $uibModalInstance,
    etKey,
    EmailTemplatesApi,
    locations,
    countries,
    handleError,
    $timeout
) {
    // properties
    $scope.isLoading = false;
    $scope.isLoadingMessage = 'Loading...';
    $scope.etKey = etKey;
    $scope.thisUser = $rootScope.thisUser;
    $scope.formErrors = {};
    $scope.template = { body: '' };

    // methods
    $scope.close = $uibModalInstance.close;
    $scope.handleTemplateChange = handleTemplateChange;
    $scope.saveTemplate = saveTemplate;

    getTemplate();

    /**
     * Loads a template to be edited
     * @return {void}
     */
    function getTemplate() {
        $scope.isLoadingMessage = 'Loading template...';
        $scope.isLoading = true;

        EmailTemplatesApi.get({
            etKey: $scope.etKey,
        }, response => {
            // Add template to scope
            angular.extend($scope.template, response.data);
            $scope.isLoading = false;
        }, err => {
            $scope.isLoading = false;
            handleError(err);
        });
    }

    /**
     * Updates scope with new template content.
     *
     * @param {string} content
     * @returns {void}
     */
    function handleTemplateChange(content) {
        $scope.template.body = content;
    }

    /**
     * Attempts to create a new template from the provided form data
     * @return {void}
     */
    function saveTemplate() {
        $scope.isLoadingMessage = 'Saving template...';
        $scope.isLoading = true;

        EmailTemplatesApi.update({
            etKey,
        }, $scope.template, response => {
            // Wait for UI prettiness
            $timeout(() => {
                $scope.isLoading = false;

                // Close modal
                $uibModalInstance.close(response.data);
            }, 400);
        }, err => {
            $scope.isLoading = false;
            $scope.formErrors = err.data;
        });
    }

    $scope.$on('modal.closing', (event, reason, closed) => {
        if (!closed) {
            return event.preventDefault();
        }

        return true;
    });
}
